import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const Eyebrow = ({ children, onDark = false, className = "", ...rest }) => (
  <span className={`eyebrow ${onDark ? "eyebrow-on-dark" : ""} ${className}`} {...rest}>
    {children}
  </span>
);

export const GoldRule = ({ className = "", width = 34 }) => (
  <span className={`gold-rule ${className}`} style={{ width }} aria-hidden="true" />
);

/** Uppercase eyebrow with a leading gold hairline — used across sections. */
export const SectionLabel = ({ children, onDark = false, className = "" }) => (
  <div className={`flex items-center gap-4 ${className}`}>
    <span
      aria-hidden="true"
      className="block h-[1px] w-8 shrink-0"
      style={{ background: onDark ? "rgba(216,183,122,0.75)" : "#D8B77A" }}
    />
    <Eyebrow onDark={onDark}>{children}</Eyebrow>
  </div>
);

export const ArrowLink = ({ to, href, children, onDark = false, className = "", ...rest }) => {
  const content = (
    <>
      <span>{children}</span>
      <ArrowRight size={15} strokeWidth={1.75} aria-hidden="true" />
    </>
  );
  const cls = `arrow-link ${onDark ? "arrow-link-dark" : ""} ${className}`;
  if (href) {
    return (
      <a className={cls} href={href} {...rest}>
        {content}
      </a>
    );
  }
  return (
    <Link className={cls} to={to} {...rest}>
      {content}
    </Link>
  );
};

export const PrimaryButton = ({ to, href, children, className = "", variant = "primary", ...rest }) => {
  const cls = `btn btn-${variant} ${className}`;
  if (href) {
    return (
      <a className={cls} href={href} {...rest}>
        {children}
      </a>
    );
  }
  if (to) {
    return (
      <Link className={cls} to={to} {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <button type="button" className={cls} {...rest}>
      {children}
    </button>
  );
};

export const Hairline = ({ gold = false, className = "", onDark = false }) => (
  <div
    aria-hidden="true"
    className={className}
    style={{
      height: 1,
      width: "100%",
      background: gold
        ? "rgba(216,183,122,0.5)"
        : onDark
          ? "rgba(247,246,242,0.14)"
          : "rgba(23,21,34,0.10)",
    }}
  />
);

export const Chip = ({ children, onDark = false, className = "" }) => (
  <span className={`chip ${onDark ? "chip-dark" : ""} ${className}`}>{children}</span>
);

/** Honest marker for structured placeholder records. */
export const PlaceholderNote = ({ children, onDark = false, className = "" }) => (
  <p
    className={`text-[11.5px] tracking-[0.14em] uppercase ${className}`}
    style={{ color: onDark ? "rgba(247,246,242,0.5)" : "rgba(23,21,34,0.45)" }}
  >
    {children}
  </p>
);

export const BrandMark = ({ size = 22, className = "" }) => (
  <img
    src="/brand/lykit-mark.png"
    alt=""
    aria-hidden="true"
    className={className}
    style={{ height: size, width: "auto", display: "block" }}
  />
);
